import { useState, ChangeEvent } from 'react';

type CreditCardTermsProps = {
  callback?: (isChecked: boolean) => void;
  configuration: any;
    show_ryr?: boolean
}

export function CreditCardTerms({ callback, configuration, show_ryr = false}: CreditCardTermsProps) {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked);

    if (callback) {
      callback(event.target.checked);
    }
  };

  let ryrLinkSection = null;
  if(show_ryr){
    const ryrLinks = [];

    

    ryrLinks.push(<li><a style={{color: configuration.text_colour}} target='_blank' rel="noreferrer"  href="https://help.ryanair.com/hc/en-gb/articles/12890911974289-General-Terms-Conditions-of-Carriage">General T&C's of carriage</a></li>)

    ryrLinks.push(<li><a style={{color: configuration.text_colour}} target='_blank' rel="noreferrer"  href="https://www.ryanair.com/gb/en/corporate/terms-of-use">Terms of use</a></li>)
    ryrLinks.push(<li><a style={{color: configuration.text_colour}}  target='_blank' rel="noreferrer" href="https://www.ryanair.com/gb/en/lp/privacy-policy">Privacy policy</a></li>)
    ryrLinks.push(<li><a style={{color: configuration.text_colour}}  target='_blank' rel="noreferrer" href="https://www.ryanair.com/gb/en/cookie-policy/www_ryanair_com">Cookies</a></li>)
    ryrLinks.push(<li><a style={{color: configuration.text_colour}}  target='_blank' rel="noreferrer" href="https://www.ryanair.com/gb/en/lp/third-party-notice">Notice</a></li>)

    ryrLinkSection = <div className='ryrTerms'>Please review the folllowing links regarding your Ryanair flights.<ul>{ryrLinks}</ul></div>
  }


  return (

    <>
      {ryrLinkSection}
      <div className="credit-card-terms">
      <input
        type='checkbox'
        id='terms'
        name='terms'
        checked={isChecked}
        onChange={handleCheckboxChange}
      />
      <label htmlFor='terms'>I agree to the <a href={configuration?.booking_terms} className="credit-card-terms__link" target="_blank" rel="noreferrer">terms and conditions</a></label>
    </div>
    </>

  );
}
